// extracted by mini-css-extract-plugin
export default {"group":"group_group__gc4nz"};